export enum AuthorizationRules {
  'RolesPage' = 'employee.roles.page',
  'RolesList' = 'employee.roles.list',
  'RolesView' = 'employee.roles.view',
  'RolesCreate' = 'employee.roles.create',
  'RolesUpdate' = 'employee.roles.update',
  'RolesDelete' = 'employee.roles.delete',
  'EmployeesPage' = 'employee.employees.page',
  'EmployeesList' = 'employee.employees.list',
  'EmployeesView' = 'employee.employees.view',
  'EmployeesCreate' = 'employee.employees.create',
  'EmployeesUpdate' = 'employee.employees.update',
  'EmployeesDelete' = 'employee.employees.delete',
  'EmployeesCreatePromotion' = 'employee.employees.create-promotion',
  'EmployeesUpdatePromotion' = 'employee.employees.update-promotion',
  'EmployeesDeletePromotion' = 'employee.employees.delete-promotion',
  'ChequeGirosPage' = 'employee.cheque-giros.page',
  'ChequeGirosList' = 'employee.cheque-giros.list',
  'ChequeGirosView' = 'employee.cheque-giros.view',
  'ChequeGirosCreate' = 'employee.cheque-giros.create',
  'ChequeGirosUpdate' = 'employee.cheque-giros.update',
  'ChequeGirosDelete' = 'employee.cheque-giros.delete',
  'BankAccountsPage' = 'employee.bank-accounts.page',
  'BankAccountsList' = 'employee.bank-accounts.list',
  'BankAccountsView' = 'employee.bank-accounts.view',
  'BankAccountsCreate' = 'employee.bank-accounts.create',
  'BankAccountsUpdate' = 'employee.bank-accounts.update',
  'BankAccountsDelete' = 'employee.bank-accounts.delete',
  'CashAccountsPage' = 'employee.cash-accounts.page',
  'CashAccountsList' = 'employee.cash-accounts.list',
  'CashAccountsView' = 'employee.cash-accounts.view',
  'CashAccountsCreate' = 'employee.cash-accounts.create',
  'CashAccountsUpdate' = 'employee.cash-accounts.update',
  'CashAccountsDelete' = 'employee.cash-accounts.delete',
  'PaymentChannelsPage' = 'employee.payment-channels.page',
  'PaymentChannelsList' = 'employee.payment-channels.list',
  'PaymentChannelsView' = 'employee.payment-channels.view',
  'PaymentChannelsCreate' = 'employee.payment-channels.create',
  'PaymentChannelsUpdate' = 'employee.payment-channels.update',
  'PaymentChannelsDelete' = 'employee.payment-channels.delete',
  'TransactionCategoriesPage' = 'employee.transaction-categories.page',
  'TransactionCategoriesList' = 'employee.transaction-categories.list',
  'TransactionCategoriesView' = 'employee.transaction-categories.view',
  'TransactionCategoriesCreate' = 'employee.transaction-categories.create',
  'TransactionCategoriesUpdate' = 'employee.transaction-categories.update',
  'TransactionCategoriesDelete' = 'employee.transaction-categories.delete',
  'CommissionMastersPage' = 'employee.commission-masters.page',
  'CommissionMastersList' = 'employee.commission-masters.list',
  'CommissionMastersView' = 'employee.commission-masters.view',
  'CommissionMastersCreate' = 'employee.commission-masters.create',
  'CommissionMastersUpdate' = 'employee.commission-masters.update',
  'CommissionMastersDelete' = 'employee.commission-masters.delete',
  'BonusPeriodsPage' = 'employee.bonus-periods.page',
  'BonusPeriodsList' = 'employee.bonus-periods.list',
  'BonusPeriodsView' = 'employee.bonus-periods.view',
  'BonusPeriodsCreate' = 'employee.bonus-periods.create',
  'BonusPeriodsUpdate' = 'employee.bonus-periods.update',
  'BonusPeriodsDelete' = 'employee.bonus-periods.delete',
  'BonusPeriodsGetPreviousBonusPeriodEmployees' = 'employee.bonus-periods.get-previous-bonus-period-employees',
  'SalesCore' = 'employee.sales.core',
  'SalesList' = 'employee.sales.list',
  'SalesShowTransactionalFootnote' = 'employee.sales.show-transactional-footnote',
  'SalesUpdateTransactionalFootnote' = 'employee.sales.update-transactional-footnote',
  'SalesAddToProject' = 'employee.sales.add-to-project',
  'SalesGetOtherExpenses' = 'employee.sales.get-other-expenses',
  'SalesGetOtherIncomes' = 'employee.sales.get-other-incomes',
  'SalesGetRefundSales' = 'employee.sales.get-refund-sales',
  'SalesGetSaleDetail' = 'employee.sales.get-sale-detail',
  'SalesGetRefundSalePurchases' = 'employee.sales.get-refund-sale-purchases',
  'SalesRevertDraft' = 'employee.sales.revert-draft',
  'PurchasesCore' = 'employee.purchases.core',
  'PurchasesList' = 'employee.purchases.list',
  'PurchasesView' = 'employee.purchases.view',
  'PurchasesGetPurchaseDetail' = 'employee.purchases.get-purchase-detail',
  'PurchasesReceiveCommission' = 'employee.purchases.receive-commission',
  'PurchasesShowTransactionalFootnote' = 'employee.purchases.show-transactional-footnote',
  'PurchasesUpdateTransactionalFootnote' = 'employee.purchases.update-transactional-footnote',
  'PurchasesRevertDraft' = 'employee.purchases.revert-draft',
  'FlightSalesPage' = 'employee.flight-sales.page',
  'FlightSalesList' = 'employee.flight-sales.list',
  'FlightSalesView' = 'employee.flight-sales.view',
  'FlightSalesCreate' = 'employee.flight-sales.create',
  'FlightSalesAction' = 'employee.flight-sales.action',
  'FlightSalesVoid' = 'employee.flight-sales.void',
  'FlightSalesRevertVoid' = 'employee.flight-sales.revert-void',
  'FlightSalesComplete' = 'employee.flight-sales.complete',
  'FlightSalesRevertComplete' = 'employee.flight-sales.revert-complete',
  'FlightSalesResolve' = 'employee.flight-sales.resolve',
  'FlightSalesOpenTicket' = 'employee.flight-sales.open-ticket',
  'FlightSalesReschedule' = 'employee.flight-sales.reschedule',
  'FlightSalesGetRescheduleHistories' = 'employee.flight-sales.get-reschedule-histories',
  'FlightSalesPrintPdf' = 'employee.flight-sales.print-pdf',
  'FlightSalesRevertDraft' = 'employee.flight-sales.revert-draft',
  'FlightPurchasesPage' = 'employee.flight-purchases.page',
  'FlightPurchasesList' = 'employee.flight-purchases.list',
  'FlightPurchasesView' = 'employee.flight-purchases.view',
  'FlightPurchasesCreate' = 'employee.flight-purchases.create',
  'FlightPurchasesVoid' = 'employee.flight-purchases.void',
  'FlightPurchasesRevertVoid' = 'employee.flight-purchases.revert-void',
  'FlightPurchasesResolve' = 'employee.flight-purchases.resolve',
  'FlightPurchasesRevertDraft' = 'employee.flight-purchases.revert-draft',
  'HotelSalesPage' = 'employee.hotel-sales.page',
  'HotelSalesList' = 'employee.hotel-sales.list',
  'HotelSalesView' = 'employee.hotel-sales.view',
  'HotelSalesCreate' = 'employee.hotel-sales.create',
  'HotelSalesAction' = 'employee.hotel-sales.action',
  'HotelSalesVoid' = 'employee.hotel-sales.void',
  'HotelSalesRevertVoid' = 'employee.hotel-sales.revert-void',
  'HotelSalesComplete' = 'employee.hotel-sales.complete',
  'HotelSalesRevertComplete' = 'employee.hotel-sales.revert-complete',
  'HotelSalesResolve' = 'employee.hotel-sales.resolve',
  'HotelSalesReschedule' = 'employee.hotel-sales.reschedule',
  'HotelSalesGetRescheduleHistories' = 'employee.hotel-sales.get-reschedule-histories',
  'HotelSalesPrintPdf' = 'employee.hotel-sales.print-pdf',
  'HotelSalesPrintVoucher' = 'employee.hotel-sales.print-voucher',
  'HotelSalesRevertDraft' = 'employee.hotel-sales.revert-draft',
  'HotelPurchasesPage' = 'employee.hotel-purchases.page',
  'HotelPurchasesList' = 'employee.hotel-purchases.list',
  'HotelPurchasesView' = 'employee.hotel-purchases.view',
  'HotelPurchasesCreate' = 'employee.hotel-purchases.create',
  'HotelPurchasesVoid' = 'employee.hotel-purchases.void',
  'HotelPurchasesRevertVoid' = 'employee.hotel-purchases.revert-void',
  'HotelPurchasesResolve' = 'employee.hotel-purchases.resolve',
  'HotelPurchasesRevertDraft' = 'employee.hotel-purchases.revert-draft',
  'CruiseSalesPage' = 'employee.cruise-sales.page',
  'CruiseSalesList' = 'employee.cruise-sales.list',
  'CruiseSalesView' = 'employee.cruise-sales.view',
  'CruiseSalesCreate' = 'employee.cruise-sales.create',
  'CruiseSalesAction' = 'employee.cruise-sales.action',
  'CruiseSalesVoid' = 'employee.cruise-sales.void',
  'CruiseSalesRevertVoid' = 'employee.cruise-sales.revert-void',
  'CruiseSalesComplete' = 'employee.cruise-sales.complete',
  'CruiseSalesRevertComplete' = 'employee.cruise-sales.revert-complete',
  'CruiseSalesResolve' = 'employee.cruise-sales.resolve',
  'CruiseSalesReschedule' = 'employee.cruise-sales.reschedule',
  'CruiseSalesGetRescheduleHistories' = 'employee.cruise-sales.get-reschedule-histories',
  'CruiseSalesRevertDraft' = 'employee.cruise-sales.revert-draft',
  'CruiseSalesPrintPdf' = 'employee.cruise-sales.print-pdf',
  'CruisePurchasesPage' = 'employee.cruise-purchases.page',
  'CruisePurchasesList' = 'employee.cruise-purchases.list',
  'CruisePurchasesView' = 'employee.cruise-purchases.view',
  'CruisePurchasesCreate' = 'employee.cruise-purchases.create',
  'CruisePurchasesVoid' = 'employee.cruise-purchases.void',
  'CruisePurchasesRevertVoid' = 'employee.cruise-purchases.revert-void',
  'CruisePurchasesResolve' = 'employee.cruise-purchases.resolve',
  'CruisePurchasesRevertDraft' = 'employee.cruise-purchases.revert-draft',
  'DocumentSalesPage' = 'employee.document-sales.page',
  'DocumentSalesList' = 'employee.document-sales.list',
  'DocumentSalesView' = 'employee.document-sales.view',
  'DocumentSalesCreate' = 'employee.document-sales.create',
  'DocumentSalesUploadDocuments' = 'employee.document-sales.upload-documents',
  'DocumentSalesAction' = 'employee.document-sales.action',
  'DocumentSalesUpdateDocumentStatus' = 'employee.document-sales.update-document-status',
  'DocumentSalesVoid' = 'employee.document-sales.void',
  'DocumentSalesRevertVoid' = 'employee.document-sales.revert-void',
  'DocumentSalesResolve' = 'employee.document-sales.resolve',
  'DocumentSalesRevertDraft' = 'employee.document-sales.revert-draft',
  'DocumentSalesPrintPdf' = 'employee.document-sales.print-pdf',
  'DocumentPurchasesPage' = 'employee.document-purchases.page',
  'DocumentPurchasesList' = 'employee.document-purchases.list',
  'DocumentPurchasesView' = 'employee.document-purchases.view',
  'DocumentPurchasesCreate' = 'employee.document-purchases.create',
  'DocumentPurchasesVoid' = 'employee.document-purchases.void',
  'DocumentPurchasesResolve' = 'employee.document-purchases.resolve',
  'DocumentPurchasesRevertVoid' = 'employee.document-purchases.revert-void',
  'DocumentPurchasesRevertDraft' = 'employee.document-purchases.revert-draft',
  'ActivitySalesPage' = 'employee.activity-sales.page',
  'ActivitySalesList' = 'employee.activity-sales.list',
  'ActivitySalesView' = 'employee.activity-sales.view',
  'ActivitySalesCreate' = 'employee.activity-sales.create',
  'ActivitySalesAction' = 'employee.activity-sales.action',
  'ActivitySalesVoid' = 'employee.activity-sales.void',
  'ActivitySalesRevertVoid' = 'employee.activity-sales.revert-void',
  'ActivitySalesComplete' = 'employee.activity-sales.complete',
  'ActivitySalesRevertComplete' = 'employee.activity-sales.revert-complete',
  'ActivitySalesReschedule' = 'employee.activity-sales.reschedule',
  'ActivitySalesGetRescheduleHistories' = 'employee.activity-sales.get-reschedule-histories',
  'ActivitySalesResolve' = 'employee.activity-sales.resolve',
  'ActivitySalesRevertDraft' = 'employee.activity-sales.revert-draft',
  'ActivitySalesPrintPdf' = 'employee.activity-sales.print-pdf',
  'ActivityPurchasesPage' = 'employee.activity-purchases.page',
  'ActivityPurchasesList' = 'employee.activity-purchases.list',
  'ActivityPurchasesView' = 'employee.activity-purchases.view',
  'ActivityPurchasesCreate' = 'employee.activity-purchases.create',
  'ActivityPurchasesVoid' = 'employee.activity-purchases.void',
  'ActivityPurchasesRevertVoid' = 'employee.activity-purchases.revert-void',
  'ActivityPurchasesResolve' = 'employee.activity-purchases.resolve',
  'ActivityPurchasesRevertDraft' = 'employee.activity-purchases.revert-draft',
  'CustomersPage' = 'employee.customers.page',
  'CustomersList' = 'employee.customers.list',
  'CustomersView' = 'employee.customers.view',
  'CustomersCreate' = 'employee.customers.create',
  'CustomersUpdate' = 'employee.customers.update',
  'CustomersDelete' = 'employee.customers.delete',
  'CustomersGetReceivableSales' = 'employee.customers.get-receivable-sales',
  'CustomersUpdateSurveillance' = 'employee.customers.update-surveillance',
  'CustomersGetGuests' = 'employee.customers.get-guests',
  'CustomersCheckSimilarData' = 'employee.customers.check-similar-data',
  'AgentsPage' = 'employee.agents.page',
  'AgentsList' = 'employee.agents.list',
  'AgentsView' = 'employee.agents.view',
  'AgentsCreate' = 'employee.agents.create',
  'AgentsUpdate' = 'employee.agents.update',
  'AgentsDelete' = 'employee.agents.delete',
  'AgentsUpdateSurveillance' = 'employee.agents.update-surveillance',
  'AgentsGetPayablePurchases' = 'employee.agents.get-payable-purchases',
  'GuestsPage' = 'employee.guests.page',
  'GuestsList' = 'employee.guests.list',
  'GuestsView' = 'employee.guests.view',
  'GuestsCreate' = 'employee.guests.create',
  'GuestsUpdate' = 'employee.guests.update',
  'GuestsDelete' = 'employee.guests.delete',
  'GuestsGetList' = 'employee.guests.get-list',
  'GuestsGetCustomers' = 'employee.guests.get-customers',
  'GuestsMassUpdatePassports' = 'employee.guests.mass-update-passports',
  'GuestsGetSaleTotalPerType' = 'employee.guests.get-sale-total-per-type',
  'GuestsGetUpcomingTrips' = 'employee.guests.get-upcoming-trips',
  'GuestsGetLatestTransactions' = 'employee.guests.get-latest-transactions',
  'GuestsGetTopBookingPreferences' = 'employee.guests.get-top-booking-preferences',
  'GuestsGetTops' = 'employee.guests.get-tops',
  'GuestsGetCustomerRelations' = 'employee.guests.get-customer-relations',
  'GuestsUpdateDescription' = 'employee.guests.update-description',
  'GuestsRegular' = 'employee.guests.regular',
  'GuestsVip' = 'employee.guests.vip',
  'GuestsVvip' = 'employee.guests.vvip',
  'GuestsArtistCelebrity' = 'employee.guests.artist-celebrity',
  'PreferenceGroupsPage' = 'employee.preference-groups.page',
  'PreferenceGroupsList' = 'employee.preference-groups.list',
  'PreferenceGroupsView' = 'employee.preference-groups.view',
  'PreferenceGroupsCreate' = 'employee.preference-groups.create',
  'PreferenceGroupsUpdate' = 'employee.preference-groups.update',
  'PreferenceGroupsDelete' = 'employee.preference-groups.delete',
  'PreferenceGroupsGetAllPreferences' = 'employee.preference-groups.get-all-preferences',
  'PreferenceGroupsGetPreference' = 'employee.preference-groups.get-preference',
  'ProductsPage' = 'employee.products.page',
  'ProductsList' = 'employee.products.list',
  'ProductsView' = 'employee.products.view',
  'ProductsCreate' = 'employee.products.create',
  'ProductsUpdate' = 'employee.products.update',
  'ProductsDelete' = 'employee.products.delete',
  'ProductsGetAllVariants' = 'employee.products.get-all-variants',
  'ProductsGetVariant' = 'employee.products.get-variant',
  'ProductSalesPage' = 'employee.product-sales.page',
  'ProductSalesList' = 'employee.product-sales.list',
  'ProductSalesView' = 'employee.product-sales.view',
  'ProductSalesCreate' = 'employee.product-sales.create',
  'ProductSalesVoid' = 'employee.product-sales.void',
  'ProductSalesRevertVoid' = 'employee.product-sales.revert-void',
  'ProductSalesComplete' = 'employee.product-sales.complete',
  'ProductSalesRevertComplete' = 'employee.product-sales.revert-complete',
  'ProductSalesResolve' = 'employee.product-sales.resolve',
  'ProductSalesRevertDraft' = 'employee.product-sales.revert-draft',
  'ProductSalesPrintPdf' = 'employee.product-sales.print-pdf',
  'ProductPurchasesPage' = 'employee.product-purchases.page',
  'ProductPurchasesList' = 'employee.product-purchases.list',
  'ProductPurchasesView' = 'employee.product-purchases.view',
  'ProductPurchasesCreate' = 'employee.product-purchases.create',
  'ProductPurchasesVoid' = 'employee.product-purchases.void',
  'ProductPurchasesRevertVoid' = 'employee.product-purchases.revert-void',
  'ProductPurchasesResolve' = 'employee.product-purchases.resolve',
  'ProductPurchasesRevertDraft' = 'employee.product-purchases.revert-draft',
  'ProductAdjustmentsPage' = 'employee.product-adjustments.page',
  'ProductAdjustmentsList' = 'employee.product-adjustments.list',
  'ProductAdjustmentsCreate' = 'employee.product-adjustments.create',
  'ProductAdjustmentsView' = 'employee.product-adjustments.view',
  'ProductAdjustmentsUpdate' = 'employee.product-adjustments.update',
  'ProductAdjustmentsDelete' = 'employee.product-adjustments.delete',
  'ToursPage' = 'employee.tours.page',
  'ToursList' = 'employee.tours.list',
  'ToursView' = 'employee.tours.view',
  'ToursCreate' = 'employee.tours.create',
  'ToursCancel' = 'employee.tours.cancel',
  'ToursClose' = 'employee.tours.close',
  'ToursRevertClose' = 'employee.tours.revert-close',
  'ToursGetOtherExpenses' = 'employee.tours.get-other-expenses',
  'ToursGetOtherIncomes' = 'employee.tours.get-other-incomes',
  'ToursGetCommission' = 'employee.tours.get-commission',
  'ToursGetParticipant' = 'employee.tours.get-participant',
  'ToursGetSale' = 'employee.tours.get-sale',
  'ToursGetPurchase' = 'employee.tours.get-purchase',
  'ToursRevertDraft' = 'employee.tours.revert-draft',
  'TourSalesPage' = 'employee.tour-sales.page',
  'TourSalesList' = 'employee.tour-sales.list',
  'TourSalesView' = 'employee.tour-sales.view',
  'TourSalesCreate' = 'employee.tour-sales.create',
  'TourSalesAction' = 'employee.tour-sales.action',
  'TourSalesVoid' = 'employee.tour-sales.void',
  'TourSalesRevertVoid' = 'employee.tour-sales.revert-void',
  'TourSalesComplete' = 'employee.tour-sales.complete',
  'TourSalesRevertComplete' = 'employee.tour-sales.revert-complete',
  'TourSalesResolve' = 'employee.tour-sales.resolve',
  'TourSalesRevertDraft' = 'employee.tour-sales.revert-draft',
  'TourSalesPrintPdf' = 'employee.tour-sales.print-pdf',
  'AirlinesPage' = 'employee.airlines.page',
  'AirlinesList' = 'employee.airlines.list',
  'AirlinesView' = 'employee.airlines.view',
  'AirlinesCreate' = 'employee.airlines.create',
  'AirlinesUpdate' = 'employee.airlines.update',
  'AirlinesDelete' = 'employee.airlines.delete',
  'HotelsPage' = 'employee.hotels.page',
  'HotelsList' = 'employee.hotels.list',
  'HotelsView' = 'employee.hotels.view',
  'HotelsCreate' = 'employee.hotels.create',
  'HotelsUpdate' = 'employee.hotels.update',
  'HotelsDelete' = 'employee.hotels.delete',
  'CruisesPage' = 'employee.cruises.page',
  'CruisesList' = 'employee.cruises.list',
  'CruisesView' = 'employee.cruises.view',
  'CruisesCreate' = 'employee.cruises.create',
  'CruisesUpdate' = 'employee.cruises.update',
  'CruisesDelete' = 'employee.cruises.delete',
  'ActivitiesPage' = 'employee.activities.page',
  'ActivitiesList' = 'employee.activities.list',
  'ActivitiesView' = 'employee.activities.view',
  'ActivitiesCreate' = 'employee.activities.create',
  'ActivitiesUpdate' = 'employee.activities.update',
  'ActivitiesDelete' = 'employee.activities.delete',
  'ProjectsPage' = 'employee.projects.page',
  'ProjectsList' = 'employee.projects.list',
  'ProjectsView' = 'employee.projects.view',
  'ProjectsCreate' = 'employee.projects.create',
  'ProjectsUpdate' = 'employee.projects.update',
  'ProjectsCancel' = 'employee.projects.cancel',
  'ProjectsAddSale' = 'employee.projects.add-sale',
  'ProjectsRemoveSale' = 'employee.projects.remove-sale',
  'ProjectsComplete' = 'employee.projects.complete',
  'ProjectsRevertComplete' = 'employee.projects.revert-complete',
  'ProjectsRevertDraft' = 'employee.projects.revert-draft',
  'AccountReceivablesPage' = 'employee.account-receivables.page',
  'AccountReceivablesList' = 'employee.account-receivables.list',
  'AccountReceivablesView' = 'employee.account-receivables.view',
  'AccountReceivablesCreate' = 'employee.account-receivables.create',
  'AccountReceivablesVoid' = 'employee.account-receivables.void',
  'AccountReceivablesResolve' = 'employee.account-receivables.resolve',
  'AccountReceivablesRevertDraft' = 'employee.account-receivables.revert-draft',
  'AccountPayablesPage' = 'employee.account-payables.page',
  'AccountPayablesList' = 'employee.account-payables.list',
  'AccountPayablesView' = 'employee.account-payables.view',
  'AccountPayablesCreate' = 'employee.account-payables.create',
  'AccountPayablesVoid' = 'employee.account-payables.void',
  'AccountPayablesResolve' = 'employee.account-payables.resolve',
  'AccountPayablesRevertDraft' = 'employee.account-payables.revert-draft',
  'ReceiptsPage' = 'employee.receipts.page',
  'ReceiptsList' = 'employee.receipts.list',
  'ReceiptsView' = 'employee.receipts.view',
  'ReceiptsCreate' = 'employee.receipts.create',
  'ReceiptsUpdateReceiptStatus' = 'employee.receipts.update-receipt-status',
  'ReceiptsExport' = 'employee.receipts.export',
  'ReceiptsVoid' = 'employee.receipts.void',
  'ReceiptsResolve' = 'employee.receipts.resolve',
  'ReceiptsRevertDraft' = 'employee.receipts.revert-draft',
  'ChequeNotesPage' = 'employee.cheque-notes.page',
  'ChequeNotesList' = 'employee.cheque-notes.list',
  'ChequeNotesView' = 'employee.cheque-notes.view',
  'ChequeNotesStoreClearing' = 'employee.cheque-notes.store-clearing',
  'ChequeNotesUpdateClearing' = 'employee.cheque-notes.update-clearing',
  'ChequeNotesDeleteClearing' = 'employee.cheque-notes.delete-clearing',
  'OtherExpensesView' = 'employee.other-expenses.view',
  'OtherExpensesCreate' = 'employee.other-expenses.create',
  'OtherExpensesUpdate' = 'employee.other-expenses.update',
  'OtherExpensesVoid' = 'employee.other-expenses.void',
  'OtherExpensesRevertDraft' = 'employee.other-expenses.revert-draft',
  'OtherIncomesView' = 'employee.other-incomes.view',
  'OtherIncomesCreate' = 'employee.other-incomes.create',
  'OtherIncomesUpdate' = 'employee.other-incomes.update',
  'OtherIncomesVoid' = 'employee.other-incomes.void',
  'OtherIncomesRevertDraft' = 'employee.other-incomes.revert-draft',
  'BalanceAdjustmentsPage' = 'employee.balance-adjustments.page',
  'BalanceAdjustmentsList' = 'employee.balance-adjustments.list',
  'BalanceAdjustmentsView' = 'employee.balance-adjustments.view',
  'BalanceAdjustmentsCreate' = 'employee.balance-adjustments.create',
  'BalanceAdjustmentsVoid' = 'employee.balance-adjustments.void',
  'BalanceAdjustmentsResolve' = 'employee.balance-adjustments.resolve',
  'BalanceAdjustmentsRevertDraft' = 'employee.balance-adjustments.revert-draft',
  'TransfersPage' = 'employee.transfers.page',
  'TransfersList' = 'employee.transfers.list',
  'TransfersView' = 'employee.transfers.view',
  'TransfersCreate' = 'employee.transfers.create',
  'TransfersVoid' = 'employee.transfers.void',
  'TransfersResolve' = 'employee.transfers.resolve',
  'TransfersRevertDraft' = 'employee.transfers.revert-draft',
  'CashTransactionsPage' = 'employee.cash-transactions.page',
  'CashTransactionsList' = 'employee.cash-transactions.list',
  'CashTransactionsView' = 'employee.cash-transactions.view',
  'CashTransactionsCreate' = 'employee.cash-transactions.create',
  'CashTransactionsVoid' = 'employee.cash-transactions.void',
  'CashTransactionsResolve' = 'employee.cash-transactions.resolve',
  'CashTransactionsRevertDraft' = 'employee.cash-transactions.revert-draft',
  'BankTransactionsPage' = 'employee.bank-transactions.page',
  'BankTransactionsList' = 'employee.bank-transactions.list',
  'BankTransactionsView' = 'employee.bank-transactions.view',
  'BankTransactionsCreate' = 'employee.bank-transactions.create',
  'BankTransactionsVoid' = 'employee.bank-transactions.void',
  'BankTransactionsResolve' = 'employee.bank-transactions.resolve',
  'BankTransactionsRevertDraft' = 'employee.bank-transactions.revert-draft',
  'OrderAdjustmentsPage' = 'employee.order-adjustments.page',
  'OrderAdjustmentsList' = 'employee.order-adjustments.list',
  'OrderAdjustmentsView' = 'employee.order-adjustments.view',
  'OrderAdjustmentsCreate' = 'employee.order-adjustments.create',
  'OrderAdjustmentsVoid' = 'employee.order-adjustments.void',
  'OrderAdjustmentsResolve' = 'employee.order-adjustments.resolve',
  'OrderAdjustmentsRevertDraft' = 'employee.order-adjustments.revert-draft',
  'RefundsPage' = 'employee.refunds.page',
  'RefundsList' = 'employee.refunds.list',
  'RefundsView' = 'employee.refunds.view',
  'RefundsCreate' = 'employee.refunds.create',
  'RefundsUpdate' = 'employee.refunds.update',
  'RefundsCancel' = 'employee.refunds.cancel',
  'RefundsResolve' = 'employee.refunds.resolve',
  'RefundsUpdateReleaseSale' = 'employee.refunds.update-release-sale',
  'RefundsUpdateReleasePurchase' = 'employee.refunds.update-release-purchase',
  'RefundsRevertDraft' = 'employee.refunds.revert-draft',
  'ReleaseSalesPage' = 'employee.release-sales.page',
  'ReleaseSalesList' = 'employee.release-sales.list',
  'ReleaseSalesView' = 'employee.release-sales.view',
  'ReleaseSalesRelease' = 'employee.release-sales.release',
  'ReleaseSalesResolve' = 'employee.release-sales.resolve',
  'ReleaseSalesCheckApproval' = 'employee.release-sales.check-approval',
  'ReleaseSalesRevertDraft' = 'employee.release-sales.revert-draft',
  'ReleasePurchasesPage' = 'employee.release-purchases.page',
  'ReleasePurchasesList' = 'employee.release-purchases.list',
  'ReleasePurchasesView' = 'employee.release-purchases.view',
  'ReleasePurchasesRelease' = 'employee.release-purchases.release',
  'ReleasePurchasesResolve' = 'employee.release-purchases.resolve',
  'ReleasePurchasesRevertDraft' = 'employee.release-purchases.revert-draft',
  'CroPage' = 'employee.cro.page',
  'CroGetGuestBirthdays' = 'employee.cro.get-guest-birthdays',
  'CroGetGuestDocuments' = 'employee.cro.get-guest-documents',
  'CroGetHotelSchedules' = 'employee.cro.get-hotel-schedules',
  'CroUpdateHotelSchedule' = 'employee.cro.update-hotel-schedule',
  'CroGetFlightSchedules' = 'employee.cro.get-flight-schedules',
  'CroUpdateFlightSchedule' = 'employee.cro.update-flight-schedule',
  'ReportsSale' = 'employee.reports.sale',
  'ReportsSaleExport' = 'employee.reports.sale-export',
  'ReportsIncome' = 'employee.reports.income',
  'ReportsIncomeExport' = 'employee.reports.income-export',
  'ReportsPurchase' = 'employee.reports.purchase',
  'ReportsPurchaseExport' = 'employee.reports.purchase-export',
  'ReportsAccountReceivable' = 'employee.reports.account-receivable',
  'ReportsAccountReceivableExport' = 'employee.reports.account-receivable-export',
  'ReportsAccountReceivableRegular' = 'employee.reports.account-receivable-regular',
  'ReportsAccountReceivableRegularExport' = 'employee.reports.account-receivable-regular-export',
  'ReportsAccountPayable' = 'employee.reports.account-payable',
  'ReportsAccountPayableExport' = 'employee.reports.account-payable-export',
  'ReportsAccountPayableRegular' = 'employee.reports.account-payable-regular',
  'ReportsAccountPayableRegularExport' = 'employee.reports.account-payable-regular-export',
  'ReportsFlight' = 'employee.reports.flight',
  'ReportsFlightExport' = 'employee.reports.flight-export',
  'ReportsHotel' = 'employee.reports.hotel',
  'ReportsHotelExport' = 'employee.reports.hotel-export',
  'ReportsPassportTravelDocument' = 'employee.reports.passport-travel-document',
  'ReportsPassportTravelDocumentExport' = 'employee.reports.passport-travel-document-export',
  'ReportsVisaTravelDocument' = 'employee.reports.visa-travel-document',
  'ReportsVisaTravelDocumentExport' = 'employee.reports.visa-travel-document-export',
  'ReportsApecCardTravelDocument' = 'employee.reports.apec-card-travel-document',
  'ReportsApecCardTravelDocumentExport' = 'employee.reports.apec-card-travel-document-export',
  'ReportsInsuranceTravelDocument' = 'employee.reports.insurance-travel-document',
  'ReportsInsuranceTravelDocumentExport' = 'employee.reports.insurance-travel-document-export',
  'ReportsTour' = 'employee.reports.tour',
  'ReportsTourExport' = 'employee.reports.tour-export',
  'ReportsTourDetailExport' = 'employee.reports.tour-detail-export',
  'ReportsTourDetailShow' = 'employee.reports.tour-detail-show',
  'ReportsTourDetailSale' = 'employee.reports.tour-detail-sale',
  'ReportsTourDetailPurchase' = 'employee.reports.tour-detail-purchase',
  'ReportsTourDetailOtherIncome' = 'employee.reports.tour-detail-other-income',
  'ReportsTourDetailOtherExpense' = 'employee.reports.tour-detail-other-expense',
  'ReportsTourDetailCommission' = 'employee.reports.tour-detail-commission',
  'ReportsProject' = 'employee.reports.project',
  'ReportsProjectExport' = 'employee.reports.project-export',
  'ReportsBankMutation' = 'employee.reports.bank-mutation',
  'ReportsBankMutationExport' = 'employee.reports.bank-mutation-export',
  'ReportsCashMutation' = 'employee.reports.cash-mutation',
  'ReportsCashMutationExport' = 'employee.reports.cash-mutation-export',
  'ReportsTransactionMutation' = 'employee.reports.transaction-mutation',
  'ReportsTransactionMutationExport' = 'employee.reports.transaction-mutation-export',
  'ReportsAgentMutation' = 'employee.reports.agent-mutation',
  'ReportsAgentMutationExport' = 'employee.reports.agent-mutation-export',
  'ReportsCustomerMutation' = 'employee.reports.customer-mutation',
  'ReportsCustomerMutationExport' = 'employee.reports.customer-mutation-export',
  'ReportsProfitLossMutation' = 'employee.reports.profit-loss-mutation',
  'ReportsProfitLossMutationExport' = 'employee.reports.profit-loss-mutation-export',
  'ReportsEmployeeCommission' = 'employee.reports.employee-commission',
  'ReportsEmployeeSaleBonus' = 'employee.reports.employee-sale-bonus',
  'ReportsEmployeeNonSaleBonus' = 'employee.reports.employee-non-sale-bonus',
  'TourCategoriesPage' = 'employee.tour-categories.page',
  'TourCategoriesList' = 'employee.tour-categories.list',
  'TourCategoriesView' = 'employee.tour-categories.view',
  'TourCategoriesCreate' = 'employee.tour-categories.create',
  'TourCategoriesUpdate' = 'employee.tour-categories.update',
  'TourCategoriesDelete' = 'employee.tour-categories.delete',
  'ApprovalsPage' = 'employee.approvals.page',
  'ApprovalsList' = 'employee.approvals.list',
  'ApprovalsView' = 'employee.approvals.view',
  'ApprovalsCreate' = 'employee.approvals.create',
  'ApprovalsUpdate' = 'employee.approvals.update',
  'ApprovalsDelete' = 'employee.approvals.delete',
  'ApprovalItemsPage' = 'employee.approval-items.page',
  'ApprovalItemsList' = 'employee.approval-items.list',
  'ApprovalItemsView' = 'employee.approval-items.view',
  'ApprovalItemsCreate' = 'employee.approval-items.create',
  'ApprovalItemsUpdateApprovalVerdict' = 'employee.approval-items.update-approval-verdict',
  'VisaDocumentsPage' = 'employee.visa-documents.page',
  'VisaDocumentsList' = 'employee.visa-documents.list',
  'VisaDocumentsView' = 'employee.visa-documents.view',
  'VisaDocumentsCreate' = 'employee.visa-documents.create',
  'VisaDocumentsUpdate' = 'employee.visa-documents.update',
  'VisaDocumentsDelete' = 'employee.visa-documents.delete',
  'VisaDocumentsTransactionList' = 'employee.visa-documents.transaction-list',
  'NoAuthorization' = 'noauth',
}
